import { css } from "@emotion/react";

import { StackingContextLevel } from "styles/stacking-context-level";

export const cannedResponsesStyles = css`
  bottom: calc(100% - 10px);
  left: 10px;
  position: absolute;
  z-index: ${StackingContextLevel.Dropdown};
`;
